export default __webpack_public_path__ + "static/media/verify-email.ac7f5428.svg";